module.exports = __webpack_public_path__ + "static/media/oncMap.65519adc.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/docs/assets/oncMap.PNG
// module id = 264
// module chunks = 0